// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"0ce3fb78","239":"dc50808a","453":"b93980b6","455":"581bd26d"}[chunkId] + ".chunk.js";
};